export const KNOCKOUT_STAGE_ORDER = [
  "Round of 32",
  "Round of 16",
  "Quarter-finals",
  "Semi-finals",
  "Third-place play-off",
  "Final",
] as const;

const apiStageToCanonical: Record<string, string> = {
  GROUP_STAGE: "Group stage",
  LAST_32: "Round of 32",
  LAST_16: "Round of 16",
  QUARTER_FINALS: "Quarter-finals",
  SEMI_FINALS: "Semi-finals",
  THIRD_PLACE: "Third-place play-off",
  FINAL: "Final",
};

export function mapApiStageToCanonical(rawStage: string): string {
  return apiStageToCanonical[rawStage] ?? rawStage;
}

export function isKnownStage(canonical: string): boolean {
  if (canonical === "Group stage") return true;
  return (KNOCKOUT_STAGE_ORDER as readonly string[]).includes(canonical);
}

export function stageType(canonical: string): "group" | "knockout" | "other" {
  if (canonical === "Group stage") return "group";
  if ((KNOCKOUT_STAGE_ORDER as readonly string[]).includes(canonical))
    return "knockout";
  return "other";
}
